export const FORM_FIELD_NAMES = {
    NAME: "name",
    LICENSE_ID: "licenseId"
}